import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import AOS from 'aos';
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import HomeIcon from "@mui/icons-material/Home";
import contactGif from "../Assets/Images/contact gif.gif";

function Contact() {

  useEffect(() => {
    AOS.init();
  }, []);

  const [successMessage, setSuccessMessage] = useState("");
  const formRef = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    const form = formRef.current;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const subject = form.subject.value.trim();
    const message = form.message.value.trim();

    const nameI = document.getElementById("nameI");
    const emailI = document.getElementById("emailI");
    const subjectI = document.getElementById("subjectI");
    const messageI = document.getElementById("messageI");

    let hasError = false;

    if (!name) {
      nameI.innerText = "Please fill this field ";
      hasError = true;
    } else {
      nameI.innerText = "";
    }

    if (!email) {
      emailI.innerText = "Please fill this field ";
      hasError = true;
    } else {
      emailI.innerText = "";
    }

    if (!subject) {
      subjectI.innerText = "Please fill this field ";
      hasError = true;
    } else {
      subjectI.innerText = "";
    }

    if (!message) {
      messageI.innerText = "Please fill this field ";
      hasError = true;
    } else {
      messageI.innerText = "";
    }

    if (hasError) {
      return;
    }

    emailjs
      .sendForm(
        "service_9x25qjf",
        "template_wev39ct",
        formRef.current,
        "ZFbDufHGULjHKZGqF"
      )

      .then((response) => {
        formRef.current.reset();
        setSuccessMessage("Your Message Is Sent Successfully");
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      });
  };

  return (
    <div>
      {/* <section className="inner-head" >
        <div className="overlay1">
          <div className="container py-2">
            <div className="row d-flex justify-content-cente align-items-center">
              <div className="col-md-5 head-content">
                <div className="section-header mb-3">
                  <h6>Explore Our Services</h6>
                  <h2>Imaginative Designs, Tangible Impact</h2>
                </div>
                <p>Experience boundless creativity with our graphic design services. Where ideas flourish, we bring your vision to vibrant life, ensuring a lasting impact.</p>
              </div>
              <div className="col-md-7">
                <img src={graphicsDesignServices} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section
        className="contact-header py-5"
        style={{ backgroundColor: "#f3f6fb", height: "50vh" }}
        data-aos="fade-up" data-aos-duration="2000">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-9 text-center">
              <div className="section-header mb-3">
                <h6>Reach out to us</h6>
                <h2>
                  Want To Work With Us? Partner With Farooq Graphics For
                  Creative Excellence
                </h2>
              </div>
              <p>
                Seize the opportunity to turn your vision into reality by
                collaborating with Farooq Graphics. Elevate your brand with our
                creative excellence and let's embark on a journey of innovative
                design together.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-cards p-5">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-4 mb-3" data-aos="fade-right" data-aos-duration="2000">
              <div className="card contact-info">
                <div className="contact-content">
                  <PhoneAndroidIcon className="contact-icon" />
                  <h4>Call us at:</h4>
                  <a href="tel:+923225628100">+923 225 628 100</a>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3 col-mar mt-5" data-aos="fade-down" data-aos-duration="2000">
              <div className="card contact-info">
                <div className="contact-content">
                  <AlternateEmailIcon className="contact-icon" />
                  <h4>Write us at:</h4>
                  <a href="mailto:farooqgraphics@gmail.com">
                    farooqgraphics@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3" data-aos="fade-left" data-aos-duration="2000">
              <div className="card contact-info">
                <div className="contact-content">
                  <HomeIcon className="contact-icon" />
                  <h4>Visit us:</h4>
                  <p>6 Ahmad Pura, Nomania Road, Gujranwala</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="form py-5">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center g-4">
            <div className="col-md-5" data-aos="fade-right" data-aos-duration="2000">
              <img src={contactGif} alt="contact-us" className="img-fluid" />
            </div>
            <div className="col-md-7" data-aos="fade-left" data-aos-duration="2000">
              <div className="row" >
                <div className="col-md-12">
                  <form
                    id="contactForm"
                    onSubmit={sendEmail}
                    ref={formRef}
                    className="contactform"
                  >
                    {successMessage && (
                      <div className="alert alert-info">{successMessage}</div>
                    )}

                    <div className="row">
                      <div className="col form-group">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          id="name"
                          placeholder="Your Name"
                          required
                        />
                        <div id="nameI" style={{ color: "red" }}></div>
                      </div>
                      <div className="col form-group">
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Your Email"
                          required
                        />
                        <div id="emailI" style={{ color: "red" }}></div>
                      </div>
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="subject"
                        id="subject"
                        placeholder="Subject"
                        required
                      />
                      <div id="subjectI" style={{ color: "red" }}></div>
                    </div>
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        name="message"
                        id="message"
                        rows="5"
                        placeholder="Message"
                        required
                      ></textarea>
                      <div id="messageI" style={{ color: "red" }}></div>
                    </div>
                    <div className="text-center submit-button">
                      <button type="submit">Send Message <span>&rarr;</span></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
